export default {
  // EuSortDialog.vue
  'crud.EuSortDialog.title': 'Set sorting rules',
  'crud.EuSortDialog.addRuleBtn': 'Add sorting rules',
  'crud.EuSortDialog.asc': 'Ascending',
  'crud.EuSortDialog.desc': 'Descending',
  'crud.EuSortDialog.clear': 'Clear sorting',
  'crud.EuSortDialog.cancel': 'Cancel',
  'crud.EuSortDialog.submit': 'Sort',
  // EuTableToolbar.vue
  'crud.EuTableToolbar.add': 'Add',
  'crud.EuTableToolbar.del': 'Delete',
  'crud.EuTableToolbar.export': 'Export',
  'crud.EuTableToolbar.import': 'Import',
  // IconSelect.vue
  'crud.IconSelect.placeholder': 'Enter icon pinyin',
  // ImportDialog.vue
  'crud.ImportDialog.title': 'Import',
  'crud.ImportDialog.tplFilePrefix': 'Template',
  'crud.ImportDialog.steps1Title': 'Upload Excel',
  'crud.ImportDialog.steps2Title': 'Import data',
  'crud.ImportDialog.importMode': 'Import mode:',
  'crud.ImportDialog.importMode.add': 'Only add data',
  'crud.ImportDialog.importMode.update': 'Update data',
  'crud.ImportDialog.importMode.addAndUpdate': 'Add and update data',
  'crud.ImportDialog.tip': 'To ensure the smooth import of data, we recommend that you use',
  'crud.ImportDialog.tip.standardTpl': 'Standard template',
  'crud.ImportDialog.tip.support': 'Support {sizeLimit}MB xls, xlsx format files',
  'crud.ImportDialog.upload.tip': 'Single file does not exceed {sizeLimit}MB',
  'crud.ImportDialog.upload.text': 'Drag the file here, or <em>click to upload</em>',
  'crud.ImportDialog.success.update': 'Import completed, update',
  'crud.ImportDialog.success.add': 'Data, new',
  'crud.ImportDialog.success.suffix': 'Data',
  'crud.ImportDialog.complete.prev': 'Previous',
  'crud.ImportDialog.complete.submit': 'Complete',
  // Message
  'message.head1.text': 'Notice',
  'message.head2.text': 'Announcement',
  'message.loading': 'Loading...',
  'message.noData': 'No data',
  'message.close': 'Close',
  'message.allRead': 'All read',
  // TableColumnSettingDialog.vue
  'crud.TableColumnSettingDialog.title': 'Set table column',
  'crud.TableColumnSettingDialog.reset': 'Reset preset',
  'crud.TableColumnSettingDialog.cancel': 'Cancel',
  'crud.TableColumnSettingDialog.submit': 'Confirm',
  'crud.TableColumnSettingDialog.column1': 'Column name',
  'crud.TableColumnSettingDialog.column2': 'Display',
  'crud.TableColumnSettingDialog.column3': 'Drag to sort',
  'crud.TableColumnSettingDialog.column4': 'Fixed',
  // UploadFile.vue
  'crud.UploadFile.trigger': 'Click to upload',
  'crud.UploadFile.uploadFail': 'Upload failed',
  'crud.UploadFile.size.limit': 'Upload file size cannot exceed {limit}MB',
  'crud.UploadFile.number.limit': 'Upload up to {limit} files',
  // AppContainerTabs.vue
  'layout.AppContainerTabs.refresh': 'Refresh',
  'layout.AppContainerTabs.closeOther': 'Close other',
  'layout.AppContainerTabs.closeLeft': 'Close left',
  'layout.AppContainerTabs.closeRight': 'Close right',
  'layout.AppContainerTabs.closeAll': 'Close all',
  // InnerIframe.vue
  'layout.InnerIframe.loading': 'Loading...',
  // SidebarHeader.vue
  'layout.SidebarHeader.username': 'Login name:',
  'layout.SidebarHeader.nickname': 'Name:',
  'layout.SidebarHeader.email': 'Email:',
  'layout.SidebarHeader.deptNames': 'Department:',
  'layout.SidebarHeader.personCenter': 'Personal center',
  'layout.SidebarHeader.logout': 'Logout',
  'layout.SidebarHeader.noDept': 'No department',
  'layout.SidebarHeader.logout.confirm.message': 'Are you sure to log out?',
  'layout.SidebarHeader.logout.confirm.title': 'Tips',
  'layout.SidebarHeader.logout.confirm.confirmButtonText': 'Confirm',
  'layout.SidebarHeader.logout.confirm.cancelButtonText': 'Cancel',
  // ThemeConfig.vue
  'layout.ThemeConfig.title': 'Theme configuration',
  'layout.ThemeConfig.form.layout': 'Layout',
  'layout.ThemeConfig.form.layout.column': 'Column layout: recommended for scenes with more submenus',
  'layout.ThemeConfig.form.layout.vertical': 'Vertical layout',
  'layout.ThemeConfig.form.layout.uniqueOpened': 'Keep only one submenu expanded',
  'layout.ThemeConfig.form.showTabsBar': 'Tabs',
  'layout.ThemeConfig.form.fixedTabsBar': 'Fixed tabs',
  'layout.ThemeConfig.form.showProgressBar': 'Progress bar',
  'layout.ThemeConfig.form.useUsualMenu': 'Enable quick menu',
  'layout.ThemeConfig.form.enabledWatermark': 'Enable watermark',
  'layout.ThemeConfig.form.darkMode': 'Dark mode',
  'layout.ThemeConfig.submit': 'Save',
  'layout.ThemeConfig.restore': 'Restore defaults',
  // ElementDatePickerOptions
  'elementDatePickerOptions.shortcuts.lastWeek': 'Last week',
  'elementDatePickerOptions.shortcuts.lastMonth': 'Last month',
  'elementDatePickerOptions.shortcuts.lastThreeMonths': 'Last three months',
  'elementDatePickerOptions.shortcuts.lastSixMonths': 'Last half year',
  'elementDatePickerOptions.shortcuts.lastYear': 'Last year',
  // 操作日志
  'const.BusinessTypeEnums.OTHER': 'Other',
  'const.BusinessTypeEnums.QUERY': 'Query',
  'const.BusinessTypeEnums.INSERT': 'Add',
  'const.BusinessTypeEnums.UPDATE': 'Update',
  'const.BusinessTypeEnums.DELETE': 'Delete',
  'const.BusinessTypeEnums.EXPORT': 'Export',
  'const.BusinessTypeEnums.EXPORT_TEMPLATE': 'Export template',
  'const.BusinessTypeEnums.IMPORT': 'Import',
  'const.BusinessTypeEnums.LOGIN': 'Login',
  'const.BusinessTypeEnums.LOGOUT': 'Logout',
  'const.BusinessTypeEnums.KICKOUT': 'Kickout',
  'const.BusinessTypeEnums.FORCE_LOGOUT': 'Force logout',
  'const.BusinessTypeEnums.PAUSE_RESUME_JOB': 'Pause/Resume job',
  'const.BusinessTypeEnums.EXEC_JOB': 'Execute job',
  // 菜单类型
  'const.MenuTypeEnums.DIR': 'Directory',
  'const.MenuTypeEnums.MENU': 'Menu',
  'const.MenuTypeEnums.BUTTON': 'Button',
  // 数据权限
  'const.DataScopeEnums.ALL': 'All data permissions',
  'const.DataScopeEnums.CUSTOM': 'Custom data permissions',
  'const.DataScopeEnums.DEPT': 'Department data permissions',
  'const.DataScopeEnums.DEPT_AND_CHILD': 'Department and below data permissions',
  'const.DataScopeEnums.SELF': 'Personal data permissions',
  // 通知类型
  'const.NoticeTypeEnums.INFO': 'Notice',
  'const.NoticeTypeEnums.ANNOUNCEMENT': 'Announcement',
  // errorCode
  'errorCode.401': 'Sorry, you do not have permission to access this page.',
  'errorCode.403': 'Sorry, you do not have permission to access this page.',
  'errorCode.404': 'Sorry, the page you visited does not exist.',
  'errorCode.default': 'System error, please contact the administrator.',
  // request
  'request.error.network': 'Backend interface connection exception',
  'request.error.timeout': 'System interface request timeout',
  'request.error.failed': 'System interface {msg} exception',
  'request.download.loading': 'Downloading data, please wait',
  'request.download.success': 'Operation succeeded',
  'request.download.error': 'An error occurred while downloading the file, please contact the administrator',
  // General
  'general.add': 'Add',
  'general.edit': 'Edit',
  'general.del': 'Delete',
  'general.confirm.title': 'Tips',
  'general.confirm.cancel': 'Cancel',
  'general.confirm.confirm': 'Confirm',
  'general.confirm.delete.success': 'Delete succeeded',
  'general.confirm.save.success': 'Save succeeded',
  'general.confirm.delete.batch.message': 'Are you sure you want to delete the selected {length} records?',
  'general.confirm.delete.message': 'Are you sure you want to delete "{key}"?',
  'general.form.cancel': 'Cancel',
  'general.form.submit': 'Save',
  'general.placeholder.input': 'Enter {field}',
  'general.placeholder.select': 'Select {field}',
  'general.required': '{field} cannot be null',
  'general.query.reset': 'Reset',
  'general.query.search': 'Search',
  'general.column.operation': 'Operation',
  'general.placeholder.enter.search': 'Press Enter to search',
  'general.back.prev': 'Back previous page',
  'general.info.basic': 'Basic information',
  'general.reload': 'Reload',
  'general.error.linkMissParams': 'Link missing parameter',
  'general.error.dataLoad': 'Data load exception',
  'general.submit.add.success': 'Added successfully',
  'general.submit.update.success': 'Updated successfully',
  'general.submit.update.success.tips': 'You can choose to back previous page or stay on the current page',
  'general.submit.update.success.tips.goPrev': 'Back previous page',
  'general.submit.update.success.tips.stay': 'Stay on the current page',
  // 401 Unauthorized
  '401.title': 'Sorry, you do not have permission to access this page',
  '401.desc1': 'Solution:',
  '401.desc2': 'You can request permission from your superior',
  '401.back': 'Go back to the previous page',
  // 404 Not Found
  '404.title': 'Sorry, the page cannot be accessed at the moment',
  '404.path.label': 'Access path: ',
  '404.desc1': 'Possible reasons:',
  '404.desc2': 'URL error: Please check if the address is complete or contains extra characters',
  '404.desc3': 'Network issue: Please check if your network is connected',
  '404.desc4': 'URL expired: The page may have been deleted',
  '404.back': 'Go back to the homepage',
  '404.back.prev': 'Return to the previous page',
}
